// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: 100%;
}

.fc-setup-dialog {
  width: 100%;
  max-width: 640px;
  display: flex;
  flex-direction: column;
  max-height: min(90vh, 760px);
}

.fc-setup-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 18px 20px;
  border-bottom: 1px solid #e4e8f0;
}
.fc-setup-header .title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}
.fc-setup-header span {
  font-size: 13px;
  color: #6b7280;
}
.fc-setup-header .header-copy {
  flex: 1;
  min-width: 0;
}

.back-btn,
.icon-button {
  border: none;
  background: #f3f4f6;
  border-radius: 10px;
  width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #4b5563;
  flex-shrink: 0;
}

.fc-setup-progress {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0;
  padding: 14px 20px 0;
}

.progress-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #d1d5db;
  transition: background 0.2s ease;
}
.progress-dot.active {
  background: #5ea1d8;
}

.progress-line {
  width: 48px;
  height: 2px;
  background: #e5e7eb;
  margin: 0 6px;
}
.progress-line.active {
  background: #5ea1d8;
}

.fc-setup-body {
  padding: 20px;
  overflow-y: auto;
  flex: 1;
}

.setup-lead {
  margin: 0 0 18px;
  font-size: 14px;
  color: #4b5563;
  line-height: 1.5;
}

.choice-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}
@media (max-width: 600px) {
  .choice-grid {
    grid-template-columns: 1fr;
  }
}

.choice-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  padding: 18px;
  border: 2px solid #e5e7eb;
  border-radius: 14px;
  background: #fff;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;
}
.choice-card:hover, .choice-card.selected {
  border-color: #5ea1d8;
  background: #f8fbff;
  box-shadow: 0 8px 24px rgba(94, 161, 216, 0.12);
}
.choice-card h3 {
  margin: 12px 0 6px;
  font-size: 16px;
  font-weight: 600;
  color: #111827;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}
.choice-card .choice-badge.paid {
  position: absolute !important;
  top: 10px !important;
  right: 10px !important;
  left: auto !important;
  margin: 0 !important;
  z-index: 3;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  padding: 0.3rem 0.65rem;
  border-radius: 999px;
  font-size: 0.65rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  white-space: nowrap;
  pointer-events: none;
  line-height: 1.2;
  background: #e83e8c !important;
  color: #ffffff !important;
  border: none;
  box-shadow: 0 2px 8px rgba(232, 62, 140, 0.28);
}

.choice-icon-wrap {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: #eef6fc;
  display: flex;
  align-items: center;
  justify-content: center;
}
.choice-icon-wrap mat-icon {
  color: #5ea1d8;
  font-size: 26px;
  width: 26px;
  height: 26px;
}
.choice-icon-wrap.ai {
  background: linear-gradient(135deg, #eef6fc, #ede9fe);
}
.choice-icon-wrap.ai mat-icon {
  color: #7c3aed;
}

.choice-subtitle {
  margin: 0 0 8px;
  font-size: 13px;
  color: #6b7280;
  line-height: 1.45;
}

.choice-hint {
  margin: 0 0 12px;
  font-size: 12px;
  color: #5ea1d8;
  line-height: 1.4;
  flex: 1;
}

.choice-cta {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  font-weight: 600;
  color: #1d4ed8;
}
.choice-cta mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}

.content-grid .choice-card {
  min-height: 180px;
}

:host-context(body.theme-dark) .fc-setup-dialog {
  background: #0f172a;
  color: #f3f4f6;
}
:host-context(body.theme-dark) .fc-setup-header {
  background: #111827;
  border-bottom-color: rgba(148, 163, 184, 0.28);
}
:host-context(body.theme-dark) .fc-setup-header .title {
  color: #f3f4f6;
}
:host-context(body.theme-dark) .fc-setup-header span {
  color: #94a3b8;
}
:host-context(body.theme-dark) .back-btn,
:host-context(body.theme-dark) .icon-button {
  background: #1f2937;
  color: #f3f4f6;
}
:host-context(body.theme-dark) .back-btn:hover,
:host-context(body.theme-dark) .icon-button:hover {
  background: #334155;
}
:host-context(body.theme-dark) .progress-dot {
  background: #475569;
}
:host-context(body.theme-dark) .progress-dot.active {
  background: #5ea1d8;
}
:host-context(body.theme-dark) .progress-line {
  background: #334155;
}
:host-context(body.theme-dark) .progress-line.active {
  background: #5ea1d8;
}
:host-context(body.theme-dark) .fc-setup-body {
  background: #0f172a;
}
:host-context(body.theme-dark) .setup-lead {
  color: #cbd5e1;
}
:host-context(body.theme-dark) .choice-card {
  background: #111827;
  border-color: rgba(148, 163, 184, 0.28);
  color: #f3f4f6;
}
:host-context(body.theme-dark) .choice-card:hover, :host-context(body.theme-dark) .choice-card.selected {
  background: #1e293b;
  border-color: #5ea1d8;
  box-shadow: 0 8px 24px rgba(94, 161, 216, 0.2);
}
:host-context(body.theme-dark) .choice-card h3 {
  color: #f3f4f6;
}
:host-context(body.theme-dark) .choice-icon-wrap {
  background: #1e293b;
}
:host-context(body.theme-dark) .choice-icon-wrap mat-icon {
  color: #7ab8e8;
}
:host-context(body.theme-dark) .choice-icon-wrap.ai {
  background: linear-gradient(135deg, #1e293b, #312e81);
}
:host-context(body.theme-dark) .choice-icon-wrap.ai mat-icon {
  color: #a78bfa;
}
:host-context(body.theme-dark) .choice-subtitle {
  color: #94a3b8;
}
:host-context(body.theme-dark) .choice-hint {
  color: #7ab8e8;
}
:host-context(body.theme-dark) .choice-cta {
  color: #93c5fd;
}
:host-context(body.theme-dark) .choice-badge.paid {
  background: #e83e8c !important;
  color: #ffffff !important;
  box-shadow: 0 2px 10px rgba(232, 62, 140, 0.45) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/create-flow-setup-dialog/create-flow-setup-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,WAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,4BAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;AACF;AACE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;AACJ;AAEE;EACE,eAAA;EACA,cAAA;AAAJ;AAGE;EACE,OAAA;EACA,YAAA;AADJ;;AAKA;;EAEE,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,MAAA;EACA,oBAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;AAFF;AAIE;EACE,mBAAA;AAFJ;;AAMA;EACE,WAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;AAHF;AAKE;EACE,mBAAA;AAHJ;;AAOA;EACE,aAAA;EACA,gBAAA;EACA,OAAA;AAJF;;AAOA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAJF;;AAOA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AAJF;AAME;EALF;IAMI,0BAAA;EAHF;AACF;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,WAAA;AAHF;AAKE;EAEE,qBAAA;EACA,mBAAA;EACA,+CAAA;AAJJ;AAOE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;AALJ;AAQE;EACE,6BAAA;EACA,oBAAA;EACA,sBAAA;EACA,qBAAA;EACA,oBAAA;EACA,UAAA;EACA,+BAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,8BAAA;EACA,yBAAA;EACA,YAAA;EACA,8CAAA;AANJ;;AAUA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAPF;AASE;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAPJ;AAUE;EACE,qDAAA;AARJ;AAUI;EACE,cAAA;AARN;;AAaA;EACE,eAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;AAVF;;AAaA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,OAAA;AAVF;;AAaA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAVF;AAYE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAVJ;;AAcA;EACE,iBAAA;AAXF;;AAeE;EACE,mBAAA;EACA,cAAA;AAZJ;AAeE;EACE,mBAAA;EACA,8CAAA;AAbJ;AAeI;EACE,cAAA;AAbN;AAgBI;EACE,cAAA;AAdN;AAkBE;;EAEE,mBAAA;EACA,cAAA;AAhBJ;AAkBI;;EACE,mBAAA;AAfN;AAmBE;EACE,mBAAA;AAjBJ;AAmBI;EACE,mBAAA;AAjBN;AAqBE;EACE,mBAAA;AAnBJ;AAqBI;EACE,mBAAA;AAnBN;AAuBE;EACE,mBAAA;AArBJ;AAwBE;EACE,cAAA;AAtBJ;AAyBE;EACE,mBAAA;EACA,uCAAA;EACA,cAAA;AAvBJ;AAyBI;EAEE,mBAAA;EACA,qBAAA;EACA,8CAAA;AAxBN;AA2BI;EACE,cAAA;AAzBN;AA6BE;EACE,mBAAA;AA3BJ;AA6BI;EACE,cAAA;AA3BN;AA8BI;EACE,qDAAA;AA5BN;AA8BM;EACE,cAAA;AA5BR;AAiCE;EACE,cAAA;AA/BJ;AAkCE;EACE,cAAA;AAhCJ;AAmCE;EACE,cAAA;AAjCJ;AAoCE;EACE,8BAAA;EACA,yBAAA;EACA,0DAAA;AAlCJ","sourcesContent":[":host {\n  display: block;\n  width: 100%;\n}\n\n.fc-setup-dialog {\n  width: 100%;\n  max-width: 640px;\n  display: flex;\n  flex-direction: column;\n  max-height: min(90vh, 760px);\n}\n\n.fc-setup-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 18px 20px;\n  border-bottom: 1px solid #e4e8f0;\n\n  .title {\n    margin: 0;\n    font-size: 18px;\n    font-weight: 600;\n  }\n\n  span {\n    font-size: 13px;\n    color: #6b7280;\n  }\n\n  .header-copy {\n    flex: 1;\n    min-width: 0;\n  }\n}\n\n.back-btn,\n.icon-button {\n  border: none;\n  background: #f3f4f6;\n  border-radius: 10px;\n  width: 36px;\n  height: 36px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: #4b5563;\n  flex-shrink: 0;\n}\n\n.fc-setup-progress {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0;\n  padding: 14px 20px 0;\n}\n\n.progress-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: #d1d5db;\n  transition: background 0.2s ease;\n\n  &.active {\n    background: #5ea1d8;\n  }\n}\n\n.progress-line {\n  width: 48px;\n  height: 2px;\n  background: #e5e7eb;\n  margin: 0 6px;\n\n  &.active {\n    background: #5ea1d8;\n  }\n}\n\n.fc-setup-body {\n  padding: 20px;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.setup-lead {\n  margin: 0 0 18px;\n  font-size: 14px;\n  color: #4b5563;\n  line-height: 1.5;\n}\n\n.choice-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px;\n\n  @media (max-width: 600px) {\n    grid-template-columns: 1fr;\n  }\n}\n\n.choice-card {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  text-align: left;\n  padding: 18px;\n  border: 2px solid #e5e7eb;\n  border-radius: 14px;\n  background: #fff;\n  position: relative;\n  overflow: hidden;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  width: 100%;\n\n  &:hover,\n  &.selected {\n    border-color: #5ea1d8;\n    background: #f8fbff;\n    box-shadow: 0 8px 24px rgba(94, 161, 216, 0.12);\n  }\n\n  h3 {\n    margin: 12px 0 6px;\n    font-size: 16px;\n    font-weight: 600;\n    color: #111827;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    flex-wrap: wrap;\n  }\n\n  .choice-badge.paid {\n    position: absolute !important;\n    top: 10px !important;\n    right: 10px !important;\n    left: auto !important;\n    margin: 0 !important;\n    z-index: 3;\n    display: inline-flex !important;\n    align-items: center;\n    justify-content: center;\n    padding: 0.3rem 0.65rem;\n    border-radius: 999px;\n    font-size: 0.65rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    white-space: nowrap;\n    pointer-events: none;\n    line-height: 1.2;\n    background: #e83e8c !important;\n    color: #ffffff !important;\n    border: none;\n    box-shadow: 0 2px 8px rgba(232, 62, 140, 0.28);\n  }\n}\n\n.choice-icon-wrap {\n  width: 48px;\n  height: 48px;\n  border-radius: 12px;\n  background: #eef6fc;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  mat-icon {\n    color: #5ea1d8;\n    font-size: 26px;\n    width: 26px;\n    height: 26px;\n  }\n\n  &.ai {\n    background: linear-gradient(135deg, #eef6fc, #ede9fe);\n\n    mat-icon {\n      color: #7c3aed;\n    }\n  }\n}\n\n.choice-subtitle {\n  margin: 0 0 8px;\n  font-size: 13px;\n  color: #6b7280;\n  line-height: 1.45;\n}\n\n.choice-hint {\n  margin: 0 0 12px;\n  font-size: 12px;\n  color: #5ea1d8;\n  line-height: 1.4;\n  flex: 1;\n}\n\n.choice-cta {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #1d4ed8;\n\n  mat-icon {\n    font-size: 16px;\n    width: 16px;\n    height: 16px;\n  }\n}\n\n.content-grid .choice-card {\n  min-height: 180px;\n}\n\n:host-context(body.theme-dark) {\n  .fc-setup-dialog {\n    background: #0f172a;\n    color: #f3f4f6;\n  }\n\n  .fc-setup-header {\n    background: #111827;\n    border-bottom-color: rgba(148, 163, 184, 0.28);\n\n    .title {\n      color: #f3f4f6;\n    }\n\n    span {\n      color: #94a3b8;\n    }\n  }\n\n  .back-btn,\n  .icon-button {\n    background: #1f2937;\n    color: #f3f4f6;\n\n    &:hover {\n      background: #334155;\n    }\n  }\n\n  .progress-dot {\n    background: #475569;\n\n    &.active {\n      background: #5ea1d8;\n    }\n  }\n\n  .progress-line {\n    background: #334155;\n\n    &.active {\n      background: #5ea1d8;\n    }\n  }\n\n  .fc-setup-body {\n    background: #0f172a;\n  }\n\n  .setup-lead {\n    color: #cbd5e1;\n  }\n\n  .choice-card {\n    background: #111827;\n    border-color: rgba(148, 163, 184, 0.28);\n    color: #f3f4f6;\n\n    &:hover,\n    &.selected {\n      background: #1e293b;\n      border-color: #5ea1d8;\n      box-shadow: 0 8px 24px rgba(94, 161, 216, 0.2);\n    }\n\n    h3 {\n      color: #f3f4f6;\n    }\n  }\n\n  .choice-icon-wrap {\n    background: #1e293b;\n\n    mat-icon {\n      color: #7ab8e8;\n    }\n\n    &.ai {\n      background: linear-gradient(135deg, #1e293b, #312e81);\n\n      mat-icon {\n        color: #a78bfa;\n      }\n    }\n  }\n\n  .choice-subtitle {\n    color: #94a3b8;\n  }\n\n  .choice-hint {\n    color: #7ab8e8;\n  }\n\n  .choice-cta {\n    color: #93c5fd;\n  }\n\n  .choice-badge.paid {\n    background: #e83e8c !important;\n    color: #ffffff !important;\n    box-shadow: 0 2px 10px rgba(232, 62, 140, 0.45) !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
